import { FormHeader } from "app/components/atoms/layout";
import { Select } from "app/components/atoms/select";
import Table from "app/components/atoms/table";
import Typography from "app/components/atoms/typography";
import { DateRangeInputMolecule } from "app/components/molecules/input";
import api from "app/integration/api";
import { useFetcher } from "app/integration/common/hooks";
import MainLayout from "app/layouts/main";
import { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import { defaultReportDates } from "app/common/reportDateRange";

const breadcrumbItems = [
  { label: "Laporan Toko", href: "#" },
  { label: "Penjualan per Metode Bayar", href: "#" },
];

function StoreReportSalesByPaymentMethodPage() {
  const [warehouses, setWarehouses] = useState([]);
  const [queryParams, setQueryParams] = useState({
    warehouse_id: null,
    ...defaultReportDates(),
  });

  useEffect(() => {
    const loadWarehouses = async () => {
      try {
        const response = await api.warehouse.index({ limit: 1000 });
        setWarehouses(response?.data ?? []);
      } catch (err) {
        setWarehouses([]);
      }
    };
    loadWarehouses();
  }, []);

  const warehouseOptions = [
    { value: null, label: "Semua Outlet" },
    ...warehouses.map((warehouse) => ({
      value: warehouse.id,
      label: warehouse.name,
    })),
  ];

  const [rows, , loader] = useFetcher({
    modelName: "storeReport",
    methodName: "salesByPaymentMethod",
    payload: { id: queryParams },
  });

  const exportExcel = () => {
    const dataForExcel = (Array.isArray(rows) ? rows : []).map((row) => ({
      "Metode Bayar": row.payment_method_name,
      "Jumlah Transaksi": row.transaction_count,
      Total: row.total,
    }));
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(dataForExcel, {
      header: ["Metode Bayar", "Jumlah Transaksi", "Total"],
    });
    worksheet["!cols"] = [{ wch: 25 }, { wch: 16 }, { wch: 18 }];
    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      "Penjualan per Metode Bayar"
    );
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    const formattedDate = new Date().toISOString().split("T")[0];
    link.download = `laporan_penjualan_per_metode_bayar_${formattedDate}.xlsx`;
    document.body.appendChild(link);
    link.click();
    setTimeout(() => {
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }, 100);
  };

  return (
    <MainLayout
      activeSidebarNavigation="store-report"
      activeSidebarChild="sales-by-payment-method"
      breadcrumbItems={breadcrumbItems}
      pageTitle="Laporan Penjualan per Metode Bayar"
      headingButtons={[
        {
          label: "Export Excel",
          type: "button",
          onClick: exportExcel,
        },
      ]}
    >
      <Table.Container>
        <Table.SearchBarWrapper>
          <FormHeader>
            <div className="col-span-2">
              <DateRangeInputMolecule testId="store-report-sales-by-payment-method-date-range"
                label="Tanggal"
                from={queryParams.start_date}
                to={queryParams.end_date}
                onFromChange={(e) =>
                  setQueryParams({
                    ...queryParams,
                    start_date: e.target.value,
                  })
                }
                onToChange={(e) =>
                  setQueryParams({ ...queryParams, end_date: e.target.value })
                }
              />
            </div>
            <Select testId="store-report-sales-by-payment-method-outlet-select"
              label="Outlet"
              placeholder="Filter Outlet"
              options={warehouseOptions}
              value={queryParams.warehouse_id}
              onChange={(e) =>
                setQueryParams({
                  ...queryParams,
                  warehouse_id: e.target.value,
                })
              }
              absolute={false}
            />
          </FormHeader>
        </Table.SearchBarWrapper>
        <Table.Wrapper asIndex={true}>
          <Table.Header>
            <Table.HeaderRow>
              <Table.Heading>Metode Bayar</Table.Heading>
              <Table.Heading>
                <p className="text-right">Jumlah Transaksi</p>
              </Table.Heading>
              <Table.Heading>
                <p className="text-right">Total</p>
              </Table.Heading>
            </Table.HeaderRow>
          </Table.Header>
          <Table.Body>
            {Array.isArray(rows) &&
              rows.map((row, index) => (
                <Table.BodyRow key={index}>
                  <Table.Cell>{row.payment_method_name ?? "-"}</Table.Cell>
                  <Table.Cell>
                    <p className="text-right">{row.transaction_count}</p>
                  </Table.Cell>
                  <Table.Cell fontWeight="semibold">
                    <p className="text-right">
                      <Typography.Currency number={row.total} />
                    </p>
                  </Table.Cell>
                </Table.BodyRow>
              ))}
          </Table.Body>
        </Table.Wrapper>
      </Table.Container>
      {loader.state && (
        <p className="text-sm px-2 py-1 text-gray-500 font-light">
          Memuat data...
        </p>
      )}
      {Array.isArray(rows) && rows.length === 0 && !loader.state && (
        <p className="text-sm px-2 py-1 text-gray-500 font-light">
          Tidak ada data untuk filter ini.
        </p>
      )}
    </MainLayout>
  );
}

export default StoreReportSalesByPaymentMethodPage;
